export function initTabs() {
  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const buttons = Array.from(tabs.querySelectorAll('[data-tab]'))
    const panels = Array.from(tabs.querySelectorAll('[data-tab-panel]'))
    const panelsWrapper = tabs.querySelector('[data-tab-panels]')
    const floorplanDetails = tabs.querySelector('[data-floorplan-details]')
    const floorplanDetailsJson = tabs.querySelector('[data-floorplan-details-json]')
    const floorplanData = floorplanDetailsJson ? JSON.parse(floorplanDetailsJson.textContent) : []
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    const getDetailItems = () => {
      if (!floorplanDetails) return []

      return Array.from(
        floorplanDetails.querySelectorAll(
          '[data-floorplan-detail-type], .floorplan-build-area, dl, [data-floorplan-detail-location]'
        )
      )
    }

    const cancelDetailAnimations = () => {
      getDetailItems().forEach((item) => {
        item.getAnimations().forEach((animation) => animation.cancel())
      })
    }

    const updateFloorplanDetails = (index) => {
      const detail = floorplanData[index]

      if (!floorplanDetails || !detail) return

      const type = floorplanDetails.querySelector('[data-floorplan-detail-type]')
      const area = floorplanDetails.querySelector('[data-floorplan-detail-area]')
      const baths = floorplanDetails.querySelector('[data-floorplan-detail-baths]')
      const beds = floorplanDetails.querySelector('[data-floorplan-detail-beds]')
      const location = floorplanDetails.querySelector('[data-floorplan-detail-location]')

      if (type) type.textContent = detail.type
      if (area) area.textContent = detail.area
      if (baths) baths.textContent = detail.baths
      if (beds) beds.textContent = detail.beds

      if (location) {
        location.src = detail.locationPlan
        location.alt = detail.locationAlt
        location.width = detail.locationWidth
        location.height = detail.locationHeight
      }
    }

    const transitionFloorplanDetails = (index) => {
      if (!floorplanDetails || !floorplanData[index]) return

      cancelDetailAnimations()
      updateFloorplanDetails(index)

      if (prefersReducedMotion.matches) {
        return
      }

      getDetailItems().forEach((item, itemIndex) => {
        item.animate(
          [
            { opacity: 0, transform: 'translateY(0.75rem) scale(0.985)' },
            { opacity: 1, transform: 'translateY(0) scale(1)' },
          ],
          {
            duration: 400,
            delay: itemIndex * 45,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            fill: 'both',
          }
        )
      })
    }

    // pin the wrapper to the visible panel's height so tab switches (and
    // reflows on viewport resize) animate the height instead of jumping
    if (panelsWrapper) {
      const wrapped = panels.filter((panel) => panelsWrapper.contains(panel))

      const syncHeight = () => {
        const active = wrapped.find((panel) => !panel.hidden)
        if (active) panelsWrapper.style.height = `${active.offsetHeight}px`
      }

      const observer = new ResizeObserver(syncHeight)
      wrapped.forEach((panel) => observer.observe(panel))
      syncHeight()
    }

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        const detailIndex = Number(button.dataset.floorplanDetailIndex ?? index)

        buttons.forEach((b, i) => b.setAttribute('aria-selected', String(i === index)))
        panels.forEach((panel) => {
          panel.hidden = Number(panel.dataset.tabPanel) !== index
        })

        tabs.querySelectorAll('[data-floorplan-zoom]').forEach((viewport) => {
          viewport.dispatchEvent(new CustomEvent('floorplan:reset'))
        })

        transitionFloorplanDetails(detailIndex)
      })
    })
  })
}
